export enum RoleCodes {
  Administrator = 'CMS-SYSTEM-ADMINISTRATOR',
  Employee = 'CMS-SYSTEM-EMPLOYEE'
}
